import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: 'Help', pathMatch: 'full' },
  {
    path: 'Help',
    loadChildren: () =>
      import('./help-documents/help-documents.module').then(
        (m) => m.HelpDocumentsModule
      ),
  },
  {
    path: 'AdminLookup',
    loadChildren: () =>
      import('./admin-lookup/admin-lookup.module').then(
        (m) => m.AdminLookupModule
      ),
  },
  {
    path: 'CourseLookup',
    loadChildren: () =>
      import('./course-lookup/course-lookup.module').then(
        (m) => m.CourseLookupModule
      ),
  },
  {
    path: 'ProctorLookup',
    loadChildren: () =>
      import('./proctor-lookup/proctor-lookup.module').then(
        (m) => m.ProctorLookupModule
      ),
  },
  {
    path: 'MyLogin',
    loadChildren: () =>
      import('./username-search/username-search.module').then(
        (m) => m.UsernameSearchModule
      ),
  },
  {
    path: 'TestAmplify',
    loadChildren: () =>
      import('./test-amplify/test-amplify.module').then(
        (m) => m.TestAmplifyModule
      ),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
